var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('h1',[_vm._v("Streamlabs Callback")]),_vm._v(" Streamlabs is now linked. "),_c('img',{attrs:{"src":"https://cdn.frankerfacez.com/emoticon/210748/1"}}),_vm._v(" You may close this tab. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }